import React, {createContext} from 'react';
import ReactDOM from 'react-dom';

import ConsultaPorSitio from './componentes/consulta_por_sitio/ConsultaPorSitio';
import SismoSentidoWrapper from './componentes/SismoSentidoWrapper';
import HTMLSelectTest from './componentes/pruebas/HTMLSelectTest';
import PruebaRHF from './componentes/pruebas/PruebaRHF';
import SelectTest from './componentes/pruebas/SelectTest';
import SismoSentido from './componentes/SismoSentido';
import PruebaReactTable from './componentes/pruebas/PruebaReactTable';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ResMapa from './componentes/resultados/ResMapa';
import Resultados from './componentes/resultados/Resultados';
import Test from './componentes/Prueba';
import MapaIntensidadesWrapper from './componentes/resultados/MapaIntensidadesWrapper';

ReactDOM.render(    
    <React.StrictMode>
        <BrowserRouter>
            <Routes>        
                <Route path="/" element={<SismoSentidoWrapper/>}/>                
                <Route path="res_mapa/:idSismo/:centroLat/:centroLon/:zoom" element={<MapaIntensidadesWrapper/>}/>
                <Route path="/prueba" element={<Test/>}/>
            </Routes>
        </BrowserRouter>

    </React.StrictMode>,
    document.getElementById('root')
);